import * as React from "react";
import { Button, Text, Title2 } from "@fluentui/react-components";
import {
  DocumentBulletList24Regular,
  DocumentTable24Regular,
  DocumentText24Regular,
  Open24Regular,
  SlideText24Regular,
} from "@fluentui/react-icons";

const templateChooserUrl = "https://app-dev.officekey.se/intrakey";

const quickLinks = [
  {
    label: "Brev",
    url: "https://app-dev.officekey.se/intrakey/templateid/10000",
    icon: <DocumentText24Regular />,
  },
  {
    label: "Allmänt dokument",
    url: "https://app-dev.officekey.se/intrakey/templateid/10002",
    icon: <DocumentText24Regular />,
  },
  {
    label: "Presentation",
    url: "https://app-dev.officekey.se/intrakey/templateid/10007",
    icon: <SlideText24Regular />,
  },
  {
    label: "Excel, stående",
    url: "https://app-dev.officekey.se/intrakey/templateid/10009",
    icon: <DocumentTable24Regular />,
  },
  {
    label: "Protokoll",
    url: "https://app-dev.officekey.se/intrakey/templateid/10024",
    icon: <DocumentBulletList24Regular />,
  },
];

const App: React.FC = () => {
  const openTemplateChooser = () => {
    window.open(templateChooserUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="app-shell">
      <main className="officekey-panel">
        <header className="officekey-header">
          <img className="officekey-logo" src="assets/logo-100.png" alt="" />
          <Title2 as="h1">Office Key</Title2>
        </header>

        <Button appearance="primary" size="large" icon={<Open24Regular />} onClick={openTemplateChooser}>
          Öppna mallväljaren
        </Button>

        <section className="quick-links" aria-labelledby="quick-links-title">
          <Text id="quick-links-title" className="quick-links-title" weight="semibold">
            Snabblänkar
          </Text>
          <nav className="quick-links-list" aria-label="Snabblänkar">
            {quickLinks.map((link) => (
              <a key={link.url} className="quick-link" href={link.url} target="_blank" rel="noreferrer">
                <span className="quick-link-icon" aria-hidden="true">
                  {link.icon}
                </span>
                <span className="quick-link-label">{link.label}</span>
              </a>
            ))}
          </nav>
        </section>
      </main>
    </div>
  );
};

export default App;
